import React, { useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { assets } from '../../assets';
import { useOnClickOutside } from '../../helpers/use-on-click-outside';

const opacityAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const ModalBackdrop = styled.div`
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  animation: ${opacityAnimation} 0.2s ease-out 0s 1;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalWindow = styled.div`
  position: relative;
  width: 670px;
  min-height: 160px;
  max-height: calc(100% - 30px);
  overflow-y: auto;
  padding: 20px 20px;
  border-radius: 2px;
  background-color: var(--matt-lighter-bg-color);
  margin: 0px 10px;
`;

const ModalCloseIcon = styled.img`
  width: 30px;
  height: 30px;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

const Modal = (props: {
  open?: boolean;
  children: React.ReactNode;
  onClose: () => void;
}): JSX.Element | null => {
  const modalWindowRef = useRef(null);
  useOnClickOutside(modalWindowRef, props.onClose);

  if (!props.open) {
    return null;
  }

  return (
    <ModalBackdrop>
      <ModalWindow ref={modalWindowRef}>
        {props.children} <ModalCloseIcon src={assets.icons.modal_close} onClick={props.onClose} />
      </ModalWindow>
    </ModalBackdrop>
  );
};

export default Modal;
